export default __webpack_public_path__ + "static/media/model_y.549401df.jpg";